/* eslint-disable key-spacing, no-multi-spaces */
import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import Immutable from 'immutable';
import Overlay from 'components/Overlay/Overlay';
import { scrollIfNotVisible } from 'utils/utils';
import './SelectList.scss';
import SelectListItem from './SelectListItem';

export default class SelectList extends Component {
  static propTypes = {
    onItemChange: PropTypes.func,
    type: PropTypes.string,
    elements: PropTypes.arrayOf(PropTypes.shape({
      checked: PropTypes.bool,
      contentType: PropTypes.string,
      elements: PropTypes.array,
      href: PropTypes.string,
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      unavailable: PropTypes.bool,
      value: PropTypes.any,
    })),
    appState: PropTypes.object,
    includeAllButton: PropTypes.bool,
    emptyElementsMessage: PropTypes.string,
    controlPosition: PropTypes.string,
    hasTextFilter: PropTypes.bool,
    activeIndex: PropTypes.number,
    query: PropTypes.string,
    reducedPadding: PropTypes.bool,
    darkerBlueHotelBackground: PropTypes.bool,
    checkParentOnSelect: PropTypes.bool,
  };

  static defaultProps = {
    appState: Immutable.Map(),
    controlPosition: 'right',
    elements: [],
    emptyElementsMessage: 'No items',
    hasTextFilter: false,
    includeAllButton: false,
    query: '',
    type: '',
  };

  state = {
    filterText: '',
  }

  shouldComponentUpdate = shouldPureComponentUpdate;

  scrollToActiveElement = (ref) => {
    const { checkParentOnSelect } = this.props;

    if (ref) {
      if (ref.scrollIntoViewIfNeeded) {
        ref.scrollIntoViewIfNeeded();
      } else if (checkParentOnSelect) {
        let parent = ref.parentNode;
        while (!parent.hasAttribute('data-custom-control-wrapper') && parent !== document.body) {
          parent = parent.parentNode;
        }

        if (parent !== document.body) {
          scrollIfNotVisible(ref, parent);
        }
      } else {
        ref.scrollIntoView();
      }
    }
  }

  areAllChecked(elements) {
    return elements.every(element => element.checked);
  }

  allChange = (event) => {
    event.preventDefault();
    const allButtonChecked = event.currentTarget.attributes['data-checked'].value === 'false';

    const changeElements = (elements) => {
      elements.forEach((element) => {
        if (element.checked !== allButtonChecked) {
          this.props.onItemChange(element.value, allButtonChecked);
        }
        if (element.elements) {
          changeElements(element.elements);
        }
      });
    };

    changeElements(this.props.elements);
  }

  updateTextFilter = (event) => {
    this.setState({ filterText: event.currentTarget.value });
  }

  renderAllButton() {
    const { type, controlPosition } = this.props;
    const areAllChecked = this.areAllChecked(this.props.elements);
    return (
      <li className={`select-list__list__element select-list__list__element--control-${type !== 'empty' && controlPosition}`}>
        <a href="#" onClick={this.allChange} data-checked={areAllChecked} className="select-list__list__element__link select-list__list__element__link--nesting-level-1">
          <div>
            <span className="select-list__list__element__span">All</span>
            <span className={`select-list__list__element__checkbox${areAllChecked ? '--is-checked' : ''}`} />
          </div>
        </a>
      </li>
    );
  }

  renderList(elements, nestingLevel) {
    const { hasTextFilter } = this.props;
    let list;
    let filteredElements = elements;

    if (hasTextFilter && elements) {
      const filterText = this.state.filterText.toLowerCase();
      filteredElements = elements.filter(element => element.name.toLowerCase().match(filterText));
    }

    if (filteredElements && filteredElements.length) {
      list = (
        <ul className="select-list__list">
          { (this.props.includeAllButton && nestingLevel === 1) && this.renderAllButton() }
          { filteredElements.map((element, idx) => this.renderElement(element, idx, nestingLevel)) }
        </ul>
      );
    } else if (hasTextFilter && filteredElements && !filteredElements.length) {
      list = <p className="select-list__no-elements">No matches found</p>;
    }

    return list;
  }

  renderElement(element, idx, nestingLevel) {
    const { type, controlPosition, activeIndex, query, onItemChange, darkerBlueHotelBackground } = this.props;
    const darkerBlueClassModifier = darkerBlueHotelBackground && element.contentType === 'HOTEL' ? 'select-list__list__element--dark-blue-hotel' : '';
    return (
      <li
        key={idx}
        ref={activeIndex === idx && this.scrollToActiveElement}
        className={`\
          select-list__list__element \
          select-list__list__element--control-${type !== 'empty' && controlPosition} \
          ${activeIndex === idx && 'select-list__list__element--active'} \
          ${darkerBlueClassModifier} \
        `}
      >
        <SelectListItem
          {...element}
          nestingLevel={nestingLevel}
          type={type}
          query={query}
          onItemChange={onItemChange}
        />
        {this.renderList(element.elements, nestingLevel + 1)}
      </li>
    );
  }

  render() {
    const { elements, appState, hasTextFilter, reducedPadding } = this.props;
    const nestingLevelStart = 1;
    const loadingState = appState.get('loadingState');

    return (
      <div className={`select-list ${hasTextFilter && 'select-list--has-text-filter'} ${reducedPadding ? 'select-list--reduced-padding' : ''}`}>
        { loadingState && <Overlay loaderPosition="fixed" loadingState={loadingState} /> }
        {
          hasTextFilter && (
            <div className="select-list__text-filter">
              <input autoFocus onChange={this.updateTextFilter} />
            </div>
          )
        }
        {
          elements.length ?
          this.renderList(elements, nestingLevelStart) :
          <p className="select-list__no-elements">{this.props.emptyElementsMessage}</p>
        }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SelectList/SelectList.jsx
 **/